import { object, ObjectSchema, string } from 'yup';

import { SocialSecurityNumberValue } from '@client/api';

import { countryValueSchema } from './CountryValue.schema';

const schema: ObjectSchema<SocialSecurityNumberValue> = object({
  country: countryValueSchema,
  value: string().required()
});

export { schema as socialSecurityNumberValueSchema };
